import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useCallbackRef from 'hooks/useCallbackRef';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import useQueryFilter from 'hooks/useQueryFilter';
import FilterActionWrapper from 'router/subrouters/Dash/subrouters/Business/pages/Businesses/components/filters/FilterActionWrapper';
import { Option } from 'models/Global';
import { NAVIGATION_VARIANTS, NavigationVariants } from 'models/Navigation';

import './DealsFilter.styles.scss';

type DealsFilterProps = {
  className?: string;
  options: Option[];
  variant?: NavigationVariants;
};

export const LEAD_ACTIIVTY_FILTER_KEY = 'leadActivityDealRoomId';

const DealsFilter: React.FC<DealsFilterProps> = (props) => {
  const { className, options, variant = NAVIGATION_VARIANTS.TERTIARY } = props;

  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>(null);

  const classes = classNames('deals-filter', className);

  const { t } = useTranslation();

  const { params, onFiltersApply } = useQueryFilter();

  const leadActivityDealRoomId = params[LEAD_ACTIIVTY_FILTER_KEY];

  const selectedOptions = useMemo(
    () => options.find(({ value }) => value === leadActivityDealRoomId),
    [leadActivityDealRoomId, options],
  );

  const triggerTitle = useMemo(
    () => selectedOptions?.label || t('allDeals'),
    [selectedOptions?.label, t],
  );

  const handleOnFilterClick = useCallback(
    (filter: string) => {
      onFiltersApply(LEAD_ACTIIVTY_FILTER_KEY, filter);
      dropdown?.setIsOpen(false);
    },
    [dropdown, onFiltersApply],
  );

  if (options.length < 2) return null;

  return (
    <FilterActionWrapper
      ref={dropdownRef}
      variant={variant}
      className={classes}
      trigerTitle={triggerTitle}
      renderAsPortal
      portalClassName="deals-filter__portal"
    >
      <ul>
        {[{ value: undefined, label: t('allDeals') }, ...options].map(
          ({ label, value }) => (
            <li
              key={value}
              className={classNames({
                selected: selectedOptions?.value === value,
              })}
              onClick={() => handleOnFilterClick(value)}
            >
              {label}
            </li>
          ),
        )}
      </ul>
    </FilterActionWrapper>
  );
};

export default DealsFilter;
